import React from "react";

import { trackCasesLink } from "../../../common/analytics";
import { keepAnchorInView } from "../../../common/utils/keepAnchorInView";

const TARGET = "case_studies";

// The quiet text link in the hero sentence: it takes the visitor down to the
// audit cases on this page. A plain link, so it also works before the scripts
// load and from other pages as /#case_studies. The arrow is drawn, not typed.
const CasesLink = () => {
  const go = (event) => {
    trackCasesLink("hero");
    // a new tab or window (Cmd/Ctrl/Shift-click) gets the plain link
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;
    const target = document.getElementById(TARGET);
    if (!target) return;
    event.preventDefault();
    const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({
      behavior: still ? "auto" : "smooth",
      block: "start",
    });
    try {
      window.history.replaceState(window.history.state, "", `#${TARGET}`);
    } catch (e) {
      // the address is cosmetic, the scroll already happened
    }
    keepAnchorInView(TARGET, { immediate: false });
  };

  return (
    <a className="hero_cases" href={`/#${TARGET}`} onClick={go}>
      See audit cases
      <svg viewBox="0 0 10 12" aria-hidden="true" focusable="false">
        <path
          d="M5 1v9.5M1.2 7 5 10.8 8.8 7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
};

export default CasesLink;
